<template>
  <Dialog
    v-model:visible="visible"
    :header="$t('unsupportedBrowserTitle')"
    modal
    :style="{ width: '90%', maxWidth: '500px' }"
    :dismissable-mask="true"
    :draggable="false"
  >
    <p
      class="text"
      v-html="$t('unsupportedBrowserDescr', { siteName: confMain.siteName })"
    >
    </p>

    <div class="flex items-center space-x-4 pt-4">
      <div class="flex-0">
        <a
          href="https://chromeenterprise.google/download/"
          target="_blank"
        >
          <nuxt-picture
            loading="lazy"
            :img-attrs="{alt: 'Chrome'}"
            src="/img/browser-chrome.png"
            sizes=""
          />
        </a>
      </div>
      <div class="flex-0">
        <a
          href="https://www.microsoft.com/uk-ua/edge/download?form=MA13FJ"
          target="_blank"
        >
          <nuxt-picture
            loading="lazy"
            :img-attrs="{alt: 'Edge'}"
            src="/img/browser-edge.png"
            sizes=""
          /></a>
      </div>
      <div class="flex-0">
        <a
          href="https://support.apple.com/downloads/safari"
          target="_blank"
        >
          <nuxt-picture
            loading="lazy"
            :img-attrs="{alt: 'Safari'}"
            src="/img/browser-safari.png"
            sizes=""
          /></a>
      </div>
      <div class="flex-0">
        <a
          href="https://www.opera.com/"
          target="_blank"
        >
          <nuxt-picture
            loading="lazy"
            :img-attrs="{alt: 'Opera'}"
            src="/img/browser-opera.png"
            sizes=""
          /></a>
      </div>
      <div class="flex-0">
        <a
          href="https://www.mozilla.org/en-US/firefox/new/"
          target="_blank"
        >
          <nuxt-picture
            loading="lazy"
            :img-attrs="{alt: 'Firefox'}"
            src="/img/browser-firefox.png"
            sizes=""
          /></a>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
const { confMain } = useConfig()
const { useCustomCookie } = useCustomTools()

const visible = ref(false)

const unsupportedBrowserModalNotAllow = useCustomCookie('unsupportedBrowserModalNotAllow')

/**
* MAIN LOGIC
*/
onMounted(() => {
  if (!unsupportedBrowserModalNotAllow.value) {
    visible.value = true

    unsupportedBrowserModalNotAllow.value = true
  }
})
</script>

<style lang="scss">

</style>
